import React, { Component, Fragment } from 'react';
import queryString from 'query-string';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as PaymentsActions } from 'store/ducks/payments';

import { Access } from 'common';
import { Page, Panel, Loading, Pagination, Breadcrumbs, Icon } from 'components';

class List extends Component {
  state = {
    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Pontos', to: '/points' },
      { name: 'Métodos de Pagamento', to: '' },
    ],
  };

  componentDidMount() {
    const { location, getPaymentsRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    getPaymentsRequest(page);
  }

  componentDidUpdate(oldProps) {
    const { location, getPaymentsRequest } = this.props;

    if (queryString.parse(oldProps.location.search).page !== queryString.parse(location.search).page) {
      getPaymentsRequest(queryString.parse(location.search).page);
    }
  }

  handleDelete = id => {
    this.props.deletePaymentRequest(id);
  };

  render() {
    const { breadcrumbs } = this.state;
    const { payments } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Meios de Pagamento</Page.Title>

        <Panel className="panel-list">
          {!payments.data.length && payments.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {payments.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>código</th>
                    <th>descrição do código</th>
                    <th>tipo</th>
                    <th>descrição do tipo</th>
                    <th>pontua</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>
                <tbody>
                  {!payments.data.length && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {payments.data.map((payment, index) => (
                    <tr key={payment.id}>
                      <td>{payment.attributes.external_id}</td>
                      <td>{payment.attributes.name}</td>
                      <td>{payment.attributes.type_payment}</td>
                      <td>{payment.attributes.description}</td>
                      <td className={payment.attributes.score ? 'label-active' : 'label-inactive'}>
                        {payment.attributes.score ? 'Sim' : 'Não'}
                      </td>
                      <td className="text-right">
                        {Access.hasPermissions('edit-payment-methods') && (
                          <Link to={`/points/payments/${payment.id}/edit`} className="button-icon">
                            <Icon name="pencil" />
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="6" />
                  </tr>
                </tfoot>
              </table>

              <Pagination current={payments.page} total={payments.totals} {...this.props} />

              {Access.hasPermissions('edit-payment-methods') && (
                <Link className="button-add" to="/points/payments/create">
                  Adicionar Método de Pagamento
                </Link>
              )}
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  payments: state.payments,
});

const mapActions = dispatch => bindActionCreators(PaymentsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(List);
